import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signup } from "../api/auth";
import "./SignupPage.css";
import {
  loginPathWithRedirect,
  sanitizeAuthRedirect,
} from "../utils/authRedirect";

const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = sanitizeAuthRedirect(searchParams.get("redirect"));
  const [formData, setFormData] = useState({
    firstName: "",
    surname: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
  });

  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (
      !formData.firstName ||
      !formData.surname ||
      !formData.email ||
      !formData.password ||
      !formData.confirmPassword
    ) {
      setError("Please fill in all required fields.");
      return;
    }

    try {
      const response = await signup({
        firstName: formData.firstName,
        surname: formData.surname,
        email: formData.email,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        phoneNumber: formData.phoneNumber || undefined,
        ...(redirectTo ? { redirect: redirectTo } : {}),
      });

      setMessage(
        response?.message ||
          "Signup successful. Please check your email for the verification link.",
      );
      setIsSubmitted(true);
    } catch (err: any) {
      setError(err.response?.data?.message || "Signup failed");
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-content wrapper-card green">
        <div className="info-card">
          <h1>Sign up</h1>
          <p>
            Create a profile and enjoy a better browsing experience, plus access
            to extra features! To request becoming a CSA member you need to
            create a profile as a first step. <br />
            Having a profile is free!
          </p>

          {error && <div className="alert alert-danger">{error}</div>}
          {message && <div className="alert alert-success">{message}</div>}

          {isSubmitted && (
            <button
              type="button"
              className="btn"
              onClick={() => navigate(loginPathWithRedirect(redirectTo))}
            >
              Go to login
            </button>
          )}

          {!isSubmitted && (
            <form onSubmit={handleSubmit} className="signup-form">
              <label htmlFor="firstName" className="sr-only">
                First Name
              </label>

              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="First Name *"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <label htmlFor="surname" className="sr-only">
                Surname
              </label>
              <input
                type="text"
                id="surname"
                name="surname"
                placeholder="Surname *"
                value={formData.surname}
                onChange={handleChange}
                required
              />
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <label htmlFor="phoneNumber" className="sr-only">
                Phone Number
              </label>
              <input
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                placeholder="Phone Number *"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Password *"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <label htmlFor="confirmPassword" className="sr-only">
                Confirm Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm Password *"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <button type="submit" className="btn">
                Sign Up
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignupPage;
